import {Form} from 'react-bootstrap';
import clsx from 'clsx';
import {FormikProps} from 'formik';
import {useIntl} from 'react-intl';

interface OptionType {
  value: string | number;
  label: string;
}

interface Props<T extends Record<string, any>> {
  name: keyof T & string;
  label: string;
  formik: FormikProps<T>;
  options: OptionType[];
  required?: boolean;
}

function SelectFormik<T extends Record<string, any>>({name, label, formik, options, required = true}: Props<T>) {
  const intl = useIntl();

  const {values, touched, errors, handleChange, handleBlur, handleReset} = formik;

  const value = values[name];
  const touchedField = touched[name];
  const error = errors[name];

  return (
    <Form.Group controlId={name}>
      <Form.Label className="fs-5 required" style={{fontWeight: 600}}>
        {intl.formatMessage({id: label})}
      </Form.Label>
      <Form.Select
        name={name}
        value={value}
        className={clsx(
          'form-select-sm',
          {'is-invalid': touchedField && error},
          {'is-valid': touchedField && !error}
        )}
        onChange={handleChange}
        onBlur={handleBlur}
        onReset={handleReset}
        aria-required={required}
        aria-invalid={!!(touchedField && error)}
        aria-describedby={touchedField && error ? `${name}-error` : undefined}
      >
        {options.map((option, index) => (
          <option value={option.value} key={index}>
            {option.label}
          </option>
        ))}
      </Form.Select>
      {touchedField && error && (
        <div id={`${name}-error`} className="fv-plugins-message-container">
          <div className="fv-help-block">
            <span role="alert">{String(error)}</span>
          </div>
        </div>
      )}
    </Form.Group>
  );
}

export default SelectFormik;
